module.exports = __webpack_public_path__ + "static/img/mobile-web-img-05@m.cd90fc1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ipark-duty-free/mobile-web-img-05@m.png
// module id = R5WX
// module chunks = 0